module.exports = __webpack_public_path__ + "static/media/neck1.a3b1d10f.png";